var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { getGeometryStyle, getMaximumHeight, getMaximumWidth, getMinimumHeight, getMinimumWidth } from '../../helpers/styles';
import ChildItemWidget from '../ChildItemWidget';
var StyledVBoxLayout = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  min-height: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  justify-content: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  height: ", ";\n  align-items: ", ";\n  text-align: ", ";\n  div[data-widget-type='item'] {\n    height: ", ";\n    width: ", ";\n  }\n"], ["\n  ", "\n  min-height: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  justify-content: ",
    ";\n  display: ", ";\n  flex-direction: ", ";\n  height: ", ";\n  align-items: ",
    ";\n  text-align: ",
    ";\n  div[data-widget-type='item'] {\n    height: ", ";\n    width: ", ";\n  }\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return getMinimumHeight(minimumSize);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return getMaximumHeight(maximumSize);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return getMinimumWidth(minimumSize);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return getMaximumWidth(maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    var _b;
    return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.justifyContent) !== null && _b !== void 0 ? _b : windowTheme.vBoxLayout.justifyContent;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.vBoxLayout.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.vBoxLayout.flexDirection;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.vBoxLayout.height;
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    var _b;
    return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.alignItems) !== null && _b !== void 0 ? _b : windowTheme.vBoxLayout.alignItems;
}, function (_a) {
    var windowTheme = _a.windowTheme, attributes = _a.attributes;
    var _b;
    return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.textAlign) !== null && _b !== void 0 ? _b : windowTheme.vBoxLayout.textAlign;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes === null || attributes === void 0 ? void 0 : attributes.item_height;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes === null || attributes === void 0 ? void 0 : attributes.item_width;
});
var VBoxLayout = function (props) {
    return (React.createElement(StyledVBoxLayout, __assign({}, props),
        React.createElement(ChildItemWidget, __assign({}, props))));
};
export default VBoxLayout;
var templateObject_1;
//# sourceMappingURL=index.js.map